import React, { useState } from "react";
import CalendarPage from "../CalendarPage/Calendar";
import Home from "../Home/Home";
import Header from "../Header/Header";
import CustomSVG from "../CustomSVG/CustomSVG";
import Translate from "../../Translate";
import ProgressBar from "../ProgressBar/ProgressBar";
import Room from "../Room/Room";
import "./Slider.css";
import {useNavigation} from "../../NavigationContext";
import Program from "../Program/Program";
import {useSelection} from "../../SelectionContext";
import TicketSelection from "../TicketSelection/TicketSelection";

import { GiHouse } from "react-icons/gi";
import { BsHeadsetVr } from "react-icons/bs";
import { MdOutlineTimelapse } from "react-icons/md";
import { IoTicketOutline } from "react-icons/io5";




const Slider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { isNextEnabled } = useNavigation();
    const { selection } = useSelection();
    const nextSlide = () => {
        if(isNextEnabled) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % pages.length);
        }
    };
    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + pages.length) % pages.length);
    };


    const pages = [
        { id: 1, component: <Home setCurrentIndex={setCurrentIndex} />,  icon: < GiHouse style={{ fontSize: '25px', }}/> , h1TextId: 'VRTown', h1DescriptionId: 'VRTownContext' },
        {id: 2, component: <Program setCurrentIndex={setCurrentIndex} selectedCity={selection.location}/>,  icon: <BsHeadsetVr style={{ fontSize: '25px' }}/>, h1TextId: 'Program', h1DescriptionId: 'ProgramChoose' },
        {id: 3, component: <Room setCurrentIndex={setCurrentIndex} selectedCity={selection.location}/>,  icon: <MdOutlineTimelapse style={{ fontSize: '25px' }}/>, h1TextId: 'Program', h1DescriptionId: 'ProgramСlarification' },
        { id: 4, component: <TicketSelection selectedCity={selection.location} />,  icon: <IoTicketOutline style={{ fontSize: '25px' }}/>, h1TextId: 'Ticket', h1DescriptionId: 'TicketChoose' },
    ];



    return (
        <div className="slider">
            <Header setCurrentIndex={setCurrentIndex} currentIndex={currentIndex} pages={pages} h1TextId={pages[currentIndex].h1TextId} h1DescriptionId={pages[currentIndex].h1DescriptionId}/>
            <ProgressBar
                currentStep={currentIndex}
                icons={pages.map(page => page.icon)}
            />

             <div className="slider__content">
                {pages[currentIndex].component}
            </div>
        {/*<div className="slider__controls">*/}
        {/*        <button*/}
        {/*            onClick={prevSlide}*/}
        {/*            style={{*/}
        {/*                border: 'none',*/}
        {/*                background: 'none',*/}
        {/*                cursor: 'pointer',*/}
        {/*                visibility: currentIndex === 0 ? 'hidden' : 'visible', }}*/}
        {/*        >*/}
        {/*            <CustomSVG  fillColor="#f6b5d3" ><Translate id="BackButton"/></CustomSVG>*/}
        {/*        </button>*/}
        {/*            <button*/}
        {/*                onClick={nextSlide}*/}
        {/*                style={{*/}
        {/*                    border: 'none',*/}
        {/*                    background: 'none',*/}
        {/*                    cursor: 'pointer',*/}
        {/*                    visibility: isNextEnabled ? "visible" : "hidden"*/}
        {/*                }}*/}
        {/*            >*/}
        {/*                <CustomSVG fillColor="#f6b5d3" flipped={true}><Translate id="NextButton" /></CustomSVG>*/}
        {/*            </button>*/}

        {/*    </div>*/}
        </div>
    );
};

export default Slider;